import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { useIsSmallScreen } from '../../../../../../common/hooks/useIsSmallScreen';

export const SidePanelTitle: FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLElement | null>(null);
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [screenSizeTransitionCount, setScreenSizeTransitionCount] = useState(0);
  const isSmallScreen = useIsSmallScreen();

  useEffect(() => {
    setScreenSizeTransitionCount(prevCount => prevCount + 1);
  }, [isSmallScreen]);

  useEffect(() => {
    ref.current = document.getElementById('offering-side-panel-header');
    setContainer(ref.current);
  }, [screenSizeTransitionCount]);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
